import { TextField } from "@material-ui/core";
import { Collapse } from "@material-ui/core/";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import ScrollToBottom, { useScrollToBottom } from "react-scroll-to-bottom";
import ArrowSvg from "../../../../assets/images/arrow-back.svg";
import CameraSvg from "../../../../assets/images/camera.svg";
import CamaraPurpleSvg from "../../../../assets/images/cameraPurple.svg";
import HouseSvg from "../../../../assets/images/house-gray.svg";
import Layout from "../../../components/Provider/Layout";
import QrScan from "../../../components/Provider/QrScan";
import RadioButtons from "../../../components/Provider/RadioButton";
import CustomButton from "../../../components/shared/CustomButton";
import CustomCamera from "../../../components/shared/CustomCamera";
import CustomSelect from "../../../components/shared/CustomSelect";
import Switch from "../../../components/shared/CustomSwitch";
import Loading from "../../../components/shared/Loading";
import MessageModal from "../../../components/shared/MessageModal";
import UploadButton from "../../../components/shared/UploadButton";
import AdminService from "../../../services/AdminServices";
import ProviderService from "../../../services/ProviderServices";
import "./ReceptionDetail.scss";

const ReceptionDetail = ({ match }) => {
  const history = useHistory();
  const {
    location: {
      state: { cudToProcess, sessionId, activeTab },
    },
  } = history;

  const [pickupPointId, setPickupPointId] = useState(null);
  const scrollToBottom = useScrollToBottom();
  const [loading, setLoading] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [currentScreen, setScreen] = useState(0);
  const [location, setLocation] = useState("");
  const [options, setOptions] = useState([]);
  const [otherUbication, setOtherUbication] = useState(false);
  const [otherUbicationText, setOtherUbicationText] = useState("");
  const [hasObservations, setHasObservations] = useState(false);
  const [observations, setObservations] = useState("");
  const [modalErrorLocation, setModalErrorLocation] = useState(false);
  const otherRef = useRef(null);
  let { id } = useParams();

  useEffect(() => {
    const { pickupPointId } = JSON.parse(localStorage.getItem("userappret"));
    setPickupPointId(pickupPointId);
    getOptions();
  }, []);

  const getOptions = async () => {
    const { pickupPointId } = JSON.parse(localStorage.getItem("userappret"));
    let newPlaces = [];
    try {
      setLoading(true);
      const places = await AdminService.getPlace(pickupPointId);
      console.log("UBICACIONES -->", places);
      places.forEach((p) => {
        const newplace = {
          value: p.id,
          label: p.name,
        };
        newPlaces.push(newplace);
      });
      setOptions(newPlaces);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setLocation(event.target.value);
    setOtherUbication(false);
    setOtherUbicationText("");
  };

  const handlePicture = (image) => {
    // el image es un base64 png
    if (image !== "data:,") {
      setPhoto(image);
    } else {
      setPhoto(null);
    }
    setScreen(0);
  };

  const handleAddCud = async () => {
    try {
      setLoading(true);
      const cud = {
        id: cudToProcess.id,
        photo,
        location,
        numProducts: cudToProcess.numProducts,
        sessionId: sessionId,
        type: cudToProcess.type,
        suborder: cudToProcess.id,
      };
      if (otherUbicationText) {
        const newPlace = await AdminService.createPlace(
          pickupPointId,
          otherUbicationText,
          "OTROS"
        );
        cud.location = newPlace[0].id;
      }
      const status = activeTab === 0 ? "received" : "returned";
      await ProviderService.putCuds(cud, status);
      setLoading(false);
      history.push("/return-recepcion", { sessionId });
    } catch (error) {
      console.error("ERROR AL AGREGAR", error);
      setLoading(false);
    }
  };

  const handleUpdateCud = async () => {
    try {
      setLoading(true);
      const cud = {
        id: cudToProcess.id,
        photo,
        location: cudToProcess.locationId,
        numProducts: cudToProcess.numProducts,
        sessionId: sessionId,
        type: cudToProcess.type,
        suborder: cudToProcess.id,
      };
      const response = await ProviderService.putCudsReturned(
        cud,
        "receptionCDLI"
      );
      console.log({ response });
      setLoading(false);
      history.push("/return-recepcion", { sessionId, activeTab });
    } catch (error) {
      console.error("ERROR AL AGREGAR", error);
      setLoading(false);
    }
  };

  const handleOtherClick = () => {
    setOtherUbication(!otherUbication);
    setOtherUbicationText("");
    setLocation("");
  };

  const handleScan = (data) => {
    if (data) {
      console.log(data);
      try {
        const location = JSON.parse(data).placeId;
        console.log("DATA QR -->", JSON.parse(data));
        setScreen(0);
        const founded = options.find((c) => c.value == location);
        if (founded) {
          setLocation(location);
          setOtherUbication(false);
          setOtherUbicationText("");
        } else setModalErrorLocation(true);
      } catch (e) {
        console.log("ERROR: ", e);
      }
    }
  };

  const totalSKUS = (skus) => {
    let total = 0;
    skus.map((sku) => (total += sku.quantity));
    return total;
  };
  const renderScreen = () => {
    switch (currentScreen) {
      case 1:
        return (
          <CustomCamera
            onClose={() => setScreen(0)}
            handlePicture={handlePicture}
          />
        );
      case 2:
        return (
          <QrScan
            handleScan={handleScan}
            onClose={() => setScreen(0)}
            title="Escaneo de locker"
            subtitle="Escanea el código QR ubicado en la puerta del locker."
          />
        );
      default:
        return (
          <Layout>
            <Loading visible={loading} />
            <MessageModal
              visible={modalErrorLocation}
              closeModal={() => setModalErrorLocation(false)}
              type={12}
              title="Ubicación no listada"
              txtBtn1="ESCANEAR OTRO LOCKER"
              onClickBtn1={() => {
                setModalErrorLocation(false);
                setScreen(2);
              }}
              txtBtn2="REGRESAR A LA LISTA"
              onClickBtn2={() => {
                setModalErrorLocation(false);
                setScreen(0);
              }}
              inlineButtons
            >
              <div className="modal-warning-message">
                <p>La ubicación escaneada no aparece en la lista</p>
              </div>
            </MessageModal>
            <div className="reception_detail-container">
              <ScrollToBottom className="reception_detail-subcontainer">
                <div className="reception_detail-mainheader">
                  <div
                    onClick={() =>
                      history.push("/return-recepcion", {
                        sessionId,
                        activeTab,
                      })
                    }
                  >
                    <img src={ArrowSvg} alt="atras" />
                  </div>
                  <h3>
                    Detalle de {activeTab === 1 ? "recepción" : "devolución"}
                  </h3>
                </div>
                <div className="reception_detail-header">
                  <h3>
                    {cudToProcess?.guide.includes("-") ? "OC" : "Guía"}{" "}
                    {cudToProcess?.guide}
                  </h3>
                  {cudToProcess?.skus ? (
                    <>
                      {cudToProcess?.skus.map((sku) => (
                        <h4 key={sku.sku}>
                          SKU: {sku.sku} <span>x{sku.quantity}</span>
                        </h4>
                      ))}
                      <h5>
                        {totalSKUS(cudToProcess?.skus)} PRODUCTO
                        {totalSKUS(cudToProcess?.skus) > 1 && "S"}
                      </h5>
                    </>
                  ) : (
                    <>
                      <h4>{"CUD:" + cudToProcess?.id}</h4>
                      <h5>
                        {cudToProcess?.numProducts} PRODUCTO
                        {cudToProcess?.numProducts > 1 && "S"}
                      </h5>
                    </>
                  )}
                </div>
                <div className="reception_detail-body">
                  <div className="reception_detail-evidence">
                    <h3>Evidencia</h3>
                    <UploadButton
                      image={photo ? CamaraPurpleSvg : CameraSvg}
                      text="TOMAR FOTO"
                      isCompleted={photo}
                      onClick={() => setScreen(1)}
                      bgColor="bg-color-primary"
                    />
                  </div>
                  <div className="reception_detail-observations">
                    <div className="observations-head">
                      <h3>Observaciones</h3>
                      <Switch
                        checked={hasObservations}
                        onChange={() => setHasObservations(!hasObservations)}
                        color="#9240C9"
                      />
                    </div>
                    <Collapse
                      in={hasObservations}
                      className="observations-textarea"
                    >
                      <textarea
                        value={observations}
                        onChange={(e) => setObservations(e.target.value)}
                        onClick={() => {
                          scrollToBottom();
                        }}
                      />
                    </Collapse>
                  </div>
                </div>
              </ScrollToBottom>
              <div className="reception_detail-footer">
                <CustomButton
                  color="#FF6868"
                  margin="20px 0 20px 20px"
                  onClick={() =>
                    history.push("/return-recepcion", { sessionId })
                  }
                >
                  CANCELAR
                </CustomButton>
                <CustomButton
                  filled={true}
                  margin="20px 20px 20px 0"
                  disabled={activeTab === 0 && !photo}
                  onClick={activeTab === 1 ? handleAddCud : handleUpdateCud}
                >
                  ACEPTAR
                </CustomButton>
              </div>
            </div>
          </Layout>
        );
    }
  };

  return renderScreen();
};

export default ReceptionDetail;
